/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_AsideInputs */

const en_landing_calendar_aside = /** @type {(inputs: Landing_Calendar_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live from the coaches' calendars. No account needed to look.`)
};

const pl_landing_calendar_aside = /** @type {(inputs: Landing_Calendar_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo z kalendarzy trenerów. Nie musisz mieć konta, żeby zobaczyć.`)
};

/**
* | output |
* | --- |
* | "Live from the coaches' calendars. No account needed to look." |
*
* @param {Landing_Calendar_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_aside = /** @type {((inputs?: Landing_Calendar_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_aside(inputs)
	return en_landing_calendar_aside(inputs)
});